import { ReactNode, useState } from 'react'

import { VideoModal, ImageModal, PdfModal } from 'src/components'
import { usePdfModal } from 'src/hooks'
import { Box } from '@mui/material'

interface IProps {
  type: string
  link: string
  children: ReactNode
}

export const MediaImagePreview = ({ type, link, children }: IProps) => {
  const [fullscreenImage, setFullscreenImage] = useState<string | null>(null)
  const [fullscreenVideo, setFullscreenVideo] = useState<string | null>(null)

  const {
    handleClosePdfPreview,
    handleError,
    handleLoad,
    handleLoadStart,
    iframeRef,
    isPdfVisible,
    loadError,
    pdfPreview,
    isLoading,
    setIsPdfVisible,
    setPdfPreview,
    setLoadError,
  } = usePdfModal()

  const handleCloseFullscreen = () => {
    setFullscreenImage(null)
  }

  const handleCloseVideoFullscreen = () => {
    setFullscreenVideo(null)
  }

  const handleMediaClick = () => {
    if (type === 'url') {
      window.open(link, '_blank')
    } else if (type.includes('image')) {
      setFullscreenImage(link)
    } else if (type === 'application/pdf') {
      setPdfPreview(link)
      setIsPdfVisible(true)
      setLoadError(false)
    } else if (type === 'video/mp4') {
      setFullscreenVideo(link)
    } else if (link.includes('http')) {
      window.open(link, '_blank')
    }
  }

  return (
    <>
      <Box
        sx={{ display: 'flex', width: 'fit-content', height: 'fit-content' }}
        onClick={handleMediaClick}
      >
        {children}
      </Box>
      {/* <EyeOpenedIcon size={35} onClick={handleMediaClick} /> */}
      <ImageModal handleClose={handleCloseFullscreen} imageSrc={fullscreenImage} />

      <VideoModal handleClose={handleCloseVideoFullscreen} videoSrc={fullscreenVideo} />

      <PdfModal
        handleClosePdfPreview={handleClosePdfPreview}
        handleError={handleError}
        handleLoad={handleLoad}
        handleLoadStart={handleLoadStart}
        iframeRef={iframeRef}
        isLoading={isLoading}
        isPdfVisible={isPdfVisible}
        loadError={loadError}
        pdfPreview={pdfPreview}
      />
    </>
  )
}
